<template><div class="ai-info-list">
  <h3>{{ card.title }}</h3>
  <ai-list-surface :scrolled="scrolled">
    <div ref="scroll" class="ai-list-scroll info-scroll" :class="{'is-scrollable': overflow}" tabindex="0" role="region" :aria-label="card.title" @scroll.passive="onScroll">
      <dl ref="rows"><div v-for="item in card.items" :key="item.id" class="info-row"><dt>{{ item.label }}</dt><dd>{{ item.value }}</dd></div></dl>
      <p v-if="!card.items.length">{{ card.emptyText }}</p>
    </div>
    <ai-list-footer slot="footer" :summary="summary" :notice="listNotice(card, pagination)" :loading="pagination.loading" :error="pagination.error"
      :has-more="card.hasMore" :busy="busy" @more="load(true)" />
  </ai-list-surface>

</div></template>
<script>
import { listSummary } from '../presentation/list-copy'
import behavior from '@/ai/components/mixins/card-behavior'
import scrollbarBehavior from '@/ai/components/mixins/scrollbar-behavior'
import AiListSurface from './AiListSurface.vue'
import AiListFooter from './AiListFooter.vue'
export default {
 mixins:[behavior,scrollbarBehavior],components:{AiListFooter,AiListSurface},
 computed:{summary(){return listSummary(this.card.items)}},
 data:()=>({overflow:false,scrolled:false,attempt:null}),
 mounted(){this.measure();this.fillViewport();if(typeof ResizeObserver!=='undefined'){this.observer=new ResizeObserver(this.measure);this.observer.observe(this.$refs.scroll);this.observer.observe(this.$refs.rows)}},
 updated(){this.measure();this.fillViewport()},beforeDestroy(){if(this.observer)this.observer.disconnect()},
 methods:{
  fillViewport(){if(!this.overflow && this.card.items.length)this.load()},
  measure(){const el=this.$refs.scroll;if(!el)return;this.overflow=el.scrollHeight>el.clientHeight+1;this.scrolled=this.overflow&&el.scrollTop>1},
  load(retry=false){if(this.busy||this.pagination.loading||!this.card.hasMore||(!retry&&(this.pagination.error||this.attempt===this.card.nextCursor)))return;this.attempt=this.card.nextCursor;this.$emit('page',this.card)},
  onScroll(){this.measure();const el=this.$refs.scroll;if(this.overflow&&el.scrollHeight-el.scrollTop-el.clientHeight<24)this.load()}
 }
}
</script>
<style scoped src="./cards.css"></style>
<style scoped src="./surfaces.css"></style>
<style scoped>
.info-scroll{max-height:300px}.ai-info-list .info-scroll dl{display:block;margin:0}.info-row{background:#fff;border:1px solid #dbe2ec!important;border-radius:10px;margin-bottom:10px;padding:14px 12px!important}.info-row:last-child{margin-bottom:0}.info-row dt{color:#344154}.info-row dd{font-weight:600;color:#24364d}.info-row{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:16px;padding:12px 4px;border-bottom:1px solid #e9edf5}.info-row:last-child{border:0}dl,dd{margin:0}dd{text-align:right}dt,dd{overflow-wrap:anywhere}.ai-list-footer button{border:0;background:transparent;color:#174b91;font:inherit;cursor:pointer}
</style>
